import React, { PureComponent } from 'react'
import cx from 'classnames'
import { func, string, bool } from 'prop-types'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router'
import { Text, Flex } from '@chakra-ui/react'
import { FormattedMessage } from 'react-intl'
import injectLanguage from 'src/components/LanguageWrapper/inject'
import { Left, Body } from 'src/components/Layout/Header'
import { WidgetContext } from 'src/modules/App/WidgetContext'
import { logError, storeDocumentTitle, updateDocumentTitle } from 'src/utils/helpers'
import Storage from 'src/utils/storage'

import styles from '../header.module.less'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon/index'

class HeaderContainer extends PureComponent {
  static propTypes = {
    rightRender: func,
    showBack: bool,
    showRight: bool,
    title: string,
  }

  static defaultProps = {
    showBack: true,
    showRight: true,
    rightRender: null,
    title: null,
    additionalRightActions: function() {},
  }

  componentDidMount() {
    try {
      // Only if widget and title is not already update with temporary/flashing title
      if (this.props.isWidget && Storage.getItem('hasFlashingDocumentTitle') !== '1') {
        // Save current document title
        storeDocumentTitle()
      }
    } catch (e) {
      logError('Update document title', e)
    }
  }

  onBackClick = () => {
    const { onBack, history } = this.props
    if (typeof onBack === 'function') {
      onBack()
    } else {
      history.goBack()
    }
  }

  /**
   * Returns custom document title based on current header title.
   *
   * Also updates it to storage to be ready for flashing/changing (e.g. for new chat messages).
   *
   * @return {string} New document title
   */
  handleDocumentTitle = () => {
    const { title, brand, useDefaultDocumentTitle } = this.props

    const documentTitle = useDefaultDocumentTitle || !title ? brand.name : title

    updateDocumentTitle(documentTitle)

    return documentTitle
  }

  render() {
    const {
      showBack,
      isWidget,
      title,
      brand,
      heading,
      hideOnDesktop,
      hideBackOnDesktop,
      bodyReplace,
      className,
      classNameLeft,
      classNameBody,
      style,
      showBackText,
    } = this.props

    const classNames = cx({
      [styles.header]: true,
      [styles.headerHideOnDesktop]: hideOnDesktop === true,
      [className]: !!className,
      'kiosk--chakra-colors-background-primary': true,
    })

    const classNamesLeft = cx({
      [classNameLeft]: !!classNameLeft,
      [styles.leftWithIcon]: showBackText,
    })

    const classNamesBody = cx({
      [classNameBody]: !!classNameBody,
    })

    const classNamesLeftIcon = cx({
      [styles.leftIcon]: true,
      [styles.leftIconHideOnDesktop]: hideBackOnDesktop === true,
    })
    return (
      <Flex className={classNames} style={style}>
        {!isWidget && <Helmet title={this.handleDocumentTitle()} />}
        <Left className={classNamesLeft} onClick={this.onBack}>
          <span
            // eslint-disable-next-line react/no-unknown-property
            display-if={showBack}
            className={classNamesLeftIcon}
          >
            <FontAwesomeIconComponent icon={['fal', 'angle-left']} size='sm' type='header-font' />
          </span>
          <Text
            display-if={showBackText && showBack}
            cursor={'pointer'}
            fontSize={'12px'}
            fontWeight={'bold'}
            variant='contrast'
            display={{ base: 'none', desktop: 'flex' }}
          >
            <FormattedMessage id='app.header.back' defaultMessage='back' />
          </Text>
        </Left>
        {typeof bodyReplace === 'function' ? (
          bodyReplace()
        ) : (
          <>
            <Body data-cy='headerTitle' className={classNamesBody}>
              {heading || title || brand.name}
            </Body>
          </>
        )}
      </Flex>
    )
  }
}

const HeaderContainerContext = props => (
  <WidgetContext.Consumer>
    {context => <HeaderContainer {...props} {...context} />}
  </WidgetContext.Consumer>
)

const HeaderContainerContextWithLanguage = injectLanguage(HeaderContainerContext)

export default withRouter(HeaderContainerContextWithLanguage)
